module.exports = __webpack_public_path__ + "static/media/YM79_6.8f1d1785.jpg";